export const MEDITATIONS = [
  // Anxiety & Grounding
  {
    id: 'anxiety-relief',
    title: 'Anxiety Relief',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Anxiety & Grounding',
    description: 'Calm your racing thoughts and find peace in the present moment.',
    icon: '🧘',
    color: '#4D96FF',
    hasAudio: false,
    transcript: [
      'Find a comfortable position and gently close your eyes.',
      'Take a deep breath in through your nose... and slowly exhale through your mouth.',
      'Notice any tension you may be holding in your body.',
      'With each exhale, imagine releasing that tension.',
      'Your thoughts may come and go - that\'s perfectly okay.',
      'Simply observe them like clouds passing in the sky.',
      'Return your focus to your breath whenever you drift.',
      'You are safe in this moment. You are exactly where you need to be.',
      'Continue breathing slowly and deeply.',
      'When you\'re ready, gently open your eyes.',
    ],
  },
  {
    id: 'panic-grounding',
    title: 'Panic Grounding',
    duration: '5 min',
    durationMinutes: 5,
    category: 'Anxiety & Grounding',
    description: 'Quick grounding technique for moments of panic.',
    icon: '🆘',
    color: '#E74C3C',
    hasAudio: false,
    transcript: [
      'You are safe. This feeling will pass.',
      'Place both feet firmly on the ground.',
      'Feel the solid surface beneath you.',
      'Take a slow breath in... 1, 2, 3, 4.',
      'Hold gently... 1, 2.',
      'Release slowly... 1, 2, 3, 4, 5, 6.',
      'Look around and name 5 things you can see.',
      'Touch something nearby and notice its texture.',
      'Listen for any sounds around you.',
      'You are grounded. You are present. You are safe.',
    ],
  },
  {
    id: 'safe-place',
    title: 'Safe Place Visualization',
    duration: '12 min',
    durationMinutes: 12,
    category: 'Anxiety & Grounding',
    description: 'Create and visit your personal safe haven in your mind.',
    icon: '🏡',
    color: '#27AE60',
    hasAudio: false,
    transcript: [
      'Close your eyes and take three deep breaths.',
      'Imagine a place where you feel completely safe and at peace.',
      'It could be real or imaginary - a beach, forest, cozy room.',
      'Begin to see this place clearly in your mind.',
      'Notice the colors, shapes, and lighting.',
      'What sounds do you hear in this safe place?',
      'What scents fill the air?',
      'Feel the temperature - is it warm or cool?',
      'You can visit this place anytime you need comfort.',
      'Take a moment to simply be here, completely safe.',
      'When you\'re ready, bring this feeling of safety back with you.',
      'Slowly open your eyes, keeping that peaceful feeling.',
    ],
  },
  {
    id: 'grounding-senses',
    title: 'Grounding in Senses',
    duration: '7 min',
    durationMinutes: 7,
    category: 'Anxiety & Grounding',
    description: 'Use your five senses to anchor yourself in the present.',
    icon: '✋',
    color: '#9B59B6',
    hasAudio: false,
    transcript: [
      'Let\'s ground ourselves using our senses.',
      'First, look around and find 5 things you can see.',
      'Name them silently to yourself.',
      'Now, notice 4 things you can touch or feel.',
      'The texture of your clothes, the air on your skin.',
      'Listen carefully for 3 things you can hear.',
      'Near sounds and far sounds.',
      'Can you identify 2 things you can smell?',
      'Finally, notice 1 thing you can taste.',
      'You are fully present in this moment.',
      'Take a deep breath and feel your connection to now.',
    ],
  },
  // Sleep & Relaxation
  {
    id: 'sleep-forest',
    title: 'Sleep Story: Forest Path',
    duration: '15 min',
    durationMinutes: 15,
    category: 'Sleep & Relaxation',
    description: 'A peaceful journey through a moonlit forest.',
    icon: '🌲',
    color: '#2E7D32',
    hasAudio: false,
    transcript: [
      'Settle into your bed and let your body become heavy.',
      'Imagine you\'re standing at the edge of a peaceful forest.',
      'The moon casts a soft, silvery light through the trees.',
      'You begin walking slowly down a gentle path.',
      'The ground is soft beneath your feet.',
      'Tall trees stand like quiet guardians on either side.',
      'You hear the gentle rustling of leaves in a light breeze.',
      'An owl calls softly in the distance.',
      'Each step takes you deeper into relaxation.',
      'The air is cool and fresh, carrying the scent of pine.',
      'You come to a small clearing with soft moss.',
      'Here, you can rest completely, utterly safe.',
      'Let sleep carry you gently into peaceful dreams.',
    ],
  },
  {
    id: 'sleep-stars',
    title: 'Sleep Story: Starry Night',
    duration: '15 min',
    durationMinutes: 15,
    category: 'Sleep & Relaxation',
    description: 'Drift off while gazing at a beautiful night sky.',
    icon: '🌙',
    color: '#1A237E',
    hasAudio: false,
    transcript: [
      'Let your body sink comfortably into your bed.',
      'Imagine you\'re lying on a soft blanket in a peaceful meadow.',
      'Above you, the night sky stretches endlessly.',
      'Thousands of stars twinkle in the darkness.',
      'Each star is like a tiny light of peace.',
      'Watch as some stars seem to pulse gently.',
      'The Milky Way stretches across the sky.',
      'You feel small, but completely held by the universe.',
      'A shooting star streaks across the darkness.',
      'Make a gentle wish for peaceful sleep.',
      'Let the vastness of space calm your mind.',
      'Drift away into dreams among the stars.',
    ],
  },
  {
    id: 'progressive-relax',
    title: 'Progressive Relaxation',
    duration: '12 min',
    durationMinutes: 12,
    category: 'Sleep & Relaxation',
    description: 'Systematically relax every muscle in your body.',
    icon: '😌',
    color: '#00796B',
    hasAudio: false,
    transcript: [
      'Lie down and make yourself comfortable.',
      'Starting with your toes, gently tense them for 5 seconds.',
      'Now release and feel the relaxation.',
      'Move to your feet - tense, hold, release.',
      'Your calves - tense, hold, and let go.',
      'Continue to your thighs - tense, hold, release.',
      'Your stomach muscles - tense, hold, soften.',
      'Your chest and back - tense, hold, melt.',
      'Your hands - make fists, hold, open and relax.',
      'Your arms and shoulders - tense, hold, drop.',
      'Your face - scrunch it up, hold, smooth out.',
      'Your entire body is now deeply relaxed.',
    ],
  },
  {
    id: 'evening-unwind',
    title: 'Evening Unwind',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Sleep & Relaxation',
    description: 'Release the day and prepare for restful sleep.',
    icon: '🌅',
    color: '#FF7043',
    hasAudio: false,
    transcript: [
      'As the day comes to a close, allow yourself to unwind.',
      'Acknowledge everything you experienced today.',
      'The challenges, the victories, the ordinary moments.',
      'Whatever happened, you made it through.',
      'With each breath, release the day\'s weight.',
      'There\'s nothing more you need to do right now.',
      'Tomorrow will take care of itself.',
      'For now, simply be.',
      'Feel gratitude for this moment of rest.',
      'Let your mind quiet as the day fades.',
    ],
  },
  // Compassion & Emotional Processing
  {
    id: 'loving-kindness',
    title: 'Loving-Kindness',
    duration: '12 min',
    durationMinutes: 12,
    category: 'Compassion',
    description: 'Cultivate love and compassion for yourself and others.',
    icon: '💕',
    color: '#E91E63',
    hasAudio: false,
    transcript: [
      'Sit comfortably and close your eyes.',
      'Begin by directing loving-kindness to yourself.',
      'Silently repeat: May I be happy. May I be healthy.',
      'May I be safe. May I live with ease.',
      'Now think of someone you love deeply.',
      'May they be happy. May they be healthy.',
      'May they be safe. May they live with ease.',
      'Expand to include a neutral person.',
      'Offer them the same wishes of well-being.',
      'Finally, extend to all beings everywhere.',
      'May all beings be happy, healthy, safe, and at ease.',
      'Rest in this field of boundless compassion.',
    ],
  },
  {
    id: 'compassion-difficulty',
    title: 'Compassion for Difficulty',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Compassion',
    description: 'Hold difficult emotions with gentle compassion.',
    icon: '🫂',
    color: '#8E24AA',
    hasAudio: false,
    triggerWarning: 'This meditation addresses difficult emotions.',
    transcript: [
      'This is a moment of difficulty.',
      'Difficulty is part of being human.',
      'You are not alone in this experience.',
      'Place a hand gently on your heart.',
      'Feel the warmth of your own touch.',
      'Say to yourself: It\'s okay to feel this way.',
      'I am allowed to struggle sometimes.',
      'May I be kind to myself in this moment.',
      'May I give myself the compassion I need.',
      'Breathe gently and hold yourself with care.',
    ],
  },
  {
    id: 'forgiveness',
    title: 'Forgiveness Meditation',
    duration: '15 min',
    durationMinutes: 15,
    category: 'Compassion',
    description: 'Begin the journey of releasing resentment and hurt.',
    icon: '🕊️',
    color: '#7B1FA2',
    hasAudio: false,
    triggerWarning: 'This meditation may bring up difficult memories.',
    transcript: [
      'Forgiveness is a gift you give yourself.',
      'It doesn\'t mean approving of what happened.',
      'It means freeing yourself from carrying the weight.',
      'Begin by forgiving yourself for any self-judgment.',
      'I forgive myself for times I wasn\'t perfect.',
      'Now, if you\'re willing, think of someone who hurt you.',
      'You don\'t have to forgive completely today.',
      'Just begin to consider: what would it feel like to be free?',
      'Holding onto pain hurts us most of all.',
      'Take one small step toward releasing.',
      'I am willing to begin the process of forgiveness.',
      'I do this for my own peace and freedom.',
    ],
  },
  {
    id: 'grief-companion',
    title: 'Grief Companion',
    duration: '12 min',
    durationMinutes: 12,
    category: 'Compassion',
    description: 'A gentle companion for times of loss and grief.',
    icon: '🌸',
    color: '#AD1457',
    hasAudio: false,
    triggerWarning: 'This meditation addresses grief and loss.',
    transcript: [
      'Grief is love with nowhere to go.',
      'It\'s okay to feel the depth of your loss.',
      'You don\'t have to be strong right now.',
      'Let the tears come if they need to.',
      'Your sadness honors what was precious.',
      'Breathe gently with your pain.',
      'You are not alone in this.',
      'Many hearts have felt what you feel.',
      'The love you carry doesn\'t end.',
      'It transforms but remains.',
      'Take the time you need to heal.',
      'Healing is not forgetting - it\'s integrating.',
    ],
  },
  // Focus & Productivity
  {
    id: 'morning-energize',
    title: 'Morning Energize',
    duration: '7 min',
    durationMinutes: 7,
    category: 'Focus & Energy',
    description: 'Start your day with intention and vitality.',
    icon: '☀️',
    color: '#FF9800',
    hasAudio: false,
    transcript: [
      'Good morning. Today is a fresh start.',
      'Take a deep, energizing breath.',
      'Feel alertness spreading through your body.',
      'Set an intention for today - what matters most?',
      'Visualize yourself moving through the day with ease.',
      'You have everything you need within you.',
      'Energy and focus are available to you.',
      'Take one more deep breath of possibility.',
      'Open your eyes, ready to begin.',
    ],
  },
  {
    id: 'focus-anchor',
    title: 'Focus Anchor',
    duration: '8 min',
    durationMinutes: 8,
    category: 'Focus & Energy',
    description: 'Sharpen concentration before important tasks.',
    icon: '🎯',
    color: '#F57C00',
    hasAudio: false,
    transcript: [
      'Prepare to focus your mind like a laser.',
      'Close your eyes and breathe steadily.',
      'Imagine your attention as a bright light.',
      'Direct this light to a single point.',
      'Let distracting thoughts fade to the edges.',
      'Your focus becomes clearer, sharper.',
      'You can maintain this concentration.',
      'When you open your eyes, carry this focus with you.',
    ],
  },
  {
    id: 'midday-reset',
    title: 'Midday Reset',
    duration: '5 min',
    durationMinutes: 5,
    category: 'Focus & Energy',
    description: 'Quick refresh for the afternoon ahead.',
    icon: '🔄',
    color: '#4CAF50',
    hasAudio: false,
    transcript: [
      'Pause for a moment in your busy day.',
      'Close your eyes and take three deep breaths.',
      'Release any tension from the morning.',
      'Let go of anything that\'s weighing on you.',
      'You\'re doing great.',
      'Refresh your energy for the afternoon.',
      'Open your eyes, renewed and ready.',
    ],
  },
  // Mindfulness & Awareness
  {
    id: 'breath-counting',
    title: 'Breath Counting',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Mindfulness',
    description: 'Simple breath counting for present-moment awareness.',
    icon: '🔢',
    color: '#3F51B5',
    hasAudio: false,
    transcript: [
      'Sit comfortably and close your eyes.',
      'Begin to notice your natural breath.',
      'On the exhale, silently count "one".',
      'Next exhale, count "two".',
      'Continue up to ten, then start over.',
      'If you lose count, simply begin again at one.',
      'This is practice, not perfection.',
      'The wandering mind is normal.',
      'Gently return to counting.',
      'Continue for the next few minutes.',
    ],
  },
  {
    id: 'body-scan',
    title: 'Body Scan',
    duration: '15 min',
    durationMinutes: 15,
    category: 'Mindfulness',
    description: 'Cultivate awareness of physical sensations throughout your body.',
    icon: '🧎',
    color: '#5C6BC0',
    hasAudio: false,
    transcript: [
      'Lie down or sit comfortably.',
      'Close your eyes and take a few deep breaths.',
      'Bring your attention to the top of your head.',
      'Notice any sensations without judgment.',
      'Slowly move awareness to your forehead, eyes, cheeks.',
      'Continue to your jaw, neck, and shoulders.',
      'Notice your arms, hands, and fingertips.',
      'Bring attention to your chest and heart area.',
      'Move to your stomach and lower back.',
      'Feel your hips, thighs, knees.',
      'Continue to your calves, ankles, feet, toes.',
      'Now feel your whole body as one.',
      'Rest in this complete awareness.',
    ],
  },
  {
    id: 'walking-meditation',
    title: 'Walking Meditation',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Mindfulness',
    description: 'Bring mindful awareness to the simple act of walking.',
    icon: '🚶‍♀️',
    color: '#43A047',
    hasAudio: false,
    transcript: [
      'Find a space where you can walk slowly.',
      'Stand still for a moment and feel your feet.',
      'Begin to walk very slowly.',
      'Notice the lifting of your foot.',
      'The movement through space.',
      'The placing of the foot down.',
      'Feel the shift of weight.',
      'Continue walking with complete attention.',
      'When your mind wanders, return to your feet.',
      'Each step is a moment of mindfulness.',
    ],
  },
  // Micro-Meditations
  {
    id: 'emergency-1min',
    title: 'Emergency Meditation',
    duration: '1 min',
    durationMinutes: 1,
    category: 'Micro-Meditations',
    description: 'Instant calm when you need it most.',
    icon: '⚡',
    color: '#D32F2F',
    hasAudio: false,
    transcript: [
      'Stop. You are safe right now.',
      'Take one deep breath in.',
      'Hold for a moment.',
      'Release slowly.',
      'You can handle this.',
      'One more breath. You\'ve got this.',
    ],
  },
  {
    id: '60-second-pause',
    title: '60-Second Pause',
    duration: '1 min',
    durationMinutes: 1,
    category: 'Micro-Meditations',
    description: 'A brief mindful pause in your day.',
    icon: '⏸️',
    color: '#7B1FA2',
    hasAudio: false,
    transcript: [
      'Pause whatever you\'re doing.',
      'Take three slow breaths.',
      'Notice how you\'re feeling right now.',
      'No judgment, just noticing.',
      'Continue with renewed presence.',
    ],
  },
  {
    id: '2min-arrival',
    title: '2-Minute Arrival',
    duration: '2 min',
    durationMinutes: 2,
    category: 'Micro-Meditations',
    description: 'Arrive fully in the present moment.',
    icon: '📍',
    color: '#00897B',
    hasAudio: false,
    transcript: [
      'Wherever you are, arrive here fully.',
      'Feel your feet on the ground.',
      'Notice your body in space.',
      'Take a deep breath.',
      'You are here now.',
      'Release any thoughts of past or future.',
      'This moment is enough.',
      'You are enough.',
    ],
  },
  {
    id: '3min-breath-focus',
    title: '3-Minute Breath Focus',
    duration: '3 min',
    durationMinutes: 3,
    category: 'Micro-Meditations',
    description: 'A brief but powerful breath-focused meditation.',
    icon: '🌬️',
    color: '#0288D1',
    hasAudio: false,
    transcript: [
      'Close your eyes or soften your gaze.',
      'Bring all attention to your breath.',
      'Notice the inhale - cool air entering.',
      'Notice the exhale - warm air leaving.',
      'Follow this rhythm without changing it.',
      'Just observe.',
      'Your breath, your anchor.',
      'Return to your day with clarity.',
    ],
  },
  // Resilience & Motivation
  {
    id: 'confidence-primer',
    title: 'Confidence Primer',
    duration: '8 min',
    durationMinutes: 8,
    category: 'Resilience',
    description: 'Build inner confidence and self-belief.',
    icon: '💪',
    color: '#EF6C00',
    hasAudio: false,
    transcript: [
      'Sit tall with strength and dignity.',
      'Remember a time you felt truly confident.',
      'Recall that feeling in your body.',
      'You have overcome challenges before.',
      'You have skills and strengths.',
      'Say to yourself: I am capable.',
      'I trust myself.',
      'I can handle what comes.',
      'Carry this confidence with you today.',
    ],
  },
  {
    id: 'resilience-builder',
    title: 'Resilience Builder',
    duration: '10 min',
    durationMinutes: 10,
    category: 'Resilience',
    description: 'Strengthen your ability to bounce back from difficulties.',
    icon: '🌱',
    color: '#388E3C',
    hasAudio: false,
    transcript: [
      'Life brings challenges to everyone.',
      'You have weathered storms before.',
      'Think of a difficulty you overcame.',
      'Remember the strength you found.',
      'That strength is still within you.',
      'You are more resilient than you know.',
      'Difficulties are temporary.',
      'Your ability to recover is permanent.',
      'I bend but do not break.',
      'I grow stronger through challenge.',
    ],
  },
  {
    id: 'morning-intention',
    title: 'Morning Intention Setting',
    duration: '6 min',
    durationMinutes: 6,
    category: 'Resilience',
    description: 'Set a meaningful intention for your day ahead.',
    icon: '🌅',
    color: '#FF5722',
    hasAudio: false,
    transcript: [
      'A new day awaits.',
      'Before you begin, pause.',
      'What quality do you want to embody today?',
      'Patience? Courage? Kindness? Focus?',
      'Choose one word as your intention.',
      'Hold this word in your heart.',
      'Let it guide your actions today.',
      'Return to it whenever you need direction.',
      'Today, I embody [your word].',
    ],
  },
];

export const CATEGORIES = [
  { id: 'all', name: 'All', icon: '✨' },
  { id: 'Anxiety & Grounding', name: 'Anxiety', icon: '🧘' },
  { id: 'Sleep & Relaxation', name: 'Sleep', icon: '😴' },
  { id: 'Compassion', name: 'Compassion', icon: '💕' },
  { id: 'Focus & Energy', name: 'Focus', icon: '🎯' },
  { id: 'Mindfulness', name: 'Mindful', icon: '🧘‍♀️' },
  { id: 'Micro-Meditations', name: 'Quick', icon: '⚡' },
  { id: 'Resilience', name: 'Strength', icon: '💪' },
];

